'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_dom-scroll-into-view@1.2.1@dom-scroll-into-view/lib/index.js
// module id = 93
// module chunks = 0